import { AppLanguage } from './locale'

export interface SanityEncyclopediaContent {
  title?: string
  htmlContent: { html: string }
  cssUrl: string
}

export interface EncyclopediaReference {
  title: string
  reference: string
}

export enum ColumnLayoutType {
  ONE_COLUMN = 'one-column',
  TWO_COLUMN = 'two-column',
}

export enum VaultColors {
  ORANGE = 'orange',
  PINK = 'pink',
  PURPLE = 'purple',
}

export interface LevelActivity {
  id: number
  activityCount: number
}
export interface MathVaultActivityMetadata {
  language: AppLanguage
  chest: string
  tab: number
  elevator: string
  room: string
  metaDescription: string
  keywords: string
  globalId: string
  activityNumber: number
  roomColor: VaultColors
  numberOfTabs: number
  numberOfActivities: number
  reference?: string
  references: EncyclopediaReference[]
  title: string
  points: number
  tabsActivity: LevelActivity[]
  columnLayout: ColumnLayoutType
}

export interface MathVaultActivity {
  _id: string
  metadata: MathVaultActivityMetadata
  question: MathVaultEntry
  alternatives: Alternative[]
  shouldShuffle: boolean
}

export interface MathVaultChestIdsMap {
  elevatorKey: string
  roomKey: string
  chests: Array<{
    id: string
    key: string
  }>
}

export interface MathVaultRoom {
  key: string
  elevatorKey: string
  chests: Array<{
    key: string
    tabs: Array<{
      serial: number
      activities: number[]
    }>
  }>
}
export interface Alternative {
  isCorrect: boolean
  _key: string
  entry: MathVaultEntry
}

type MathVaultEntry = Array<
  { _type: string; children: Array<{ _type: string; text?: string; body?: string }> } & Record<string, unknown>
>

export enum MathVaultScreen {
  ACTIVITY = 'activity',
  COMPLETE_CHEST = 'complete-chest',
  COMPLETE_LEVEL = 'complete-level',
  CORRECT = 'correct',
  FAILURE = 'failure',
}

export enum AnswerState {
  PENDING = 'pending',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
}

export enum VaultSpawnLocations {
  outside_vault = 'OUTSIDE_VAULT',
  lobby = 'LOBBY',
  numbers = 'ROOM_NUMBERS',
  time = 'ROOM_TIME',
  money = 'ROOM_MONEY',
  measuring = 'ROOM_MEASURING',
  statistics = 'ROOM_STATISTICS',
  planar_figures = 'ROOM_PLANAR_FIGURES',
  solid_figures = 'ROOM_SOLID_FIGURES',
}

export interface QuestionSummaryModel {
  questionNo: string | null
  passed: boolean
  numberOfTries: number
  numberOfFailures: number
  firstPassOnTryNo: number
  livesLeft: number
}

export interface LevelSummaryModel {
  noOfQuestionsPassed: number
  noOfQuestionsTried: number
  questionsAnsweredWrong: number[]
  questionsAnsweredCorrectly: number[]
  levelNumber: string
  isCompleted: boolean
  nextLevel?: number
  nextQuestion?: number
}

export interface LevelsSummaryModel {
  [key: string]: LevelSummaryModel
}

export interface SummaryModel {
  questionSummary: QuestionSummaryModel
  levelsSummary: LevelsSummaryModel
  kudosEarned: number
  streak: number
}

export interface MathVaultUserDocModel {
  kudosEarned: number
  streak: number
}

export interface SummaryQueryParams {
  id: string
  elevator: string
  floor: string
  chest: string
  level: string
  question: string
}

export interface MathVaultEventModel {
  elevatorId: string
  floorId: string
  chestId: string
  level: number
  question: number
  passed: boolean
  levelCompleted: boolean
  chestCompleted: boolean
  nextLevel: number
  nextQuestion: number
  gemType: string
}

export interface activityBeforeLogIn {
  metadata: MathVaultActivityMetadata | null
  nextActivityPath: string | null
}

export interface MathVaultState {
  currentScreen: MathVaultScreen
  answerState: AnswerState
  levelsSummary: { [key: number]: LevelSummaryModel }
  currentQuestionSummary: QuestionSummaryModel
  selectedAnswer: Alternative | null
  currentLocation: MathVaultLocation
  kudosEarned: number
  answerBeforeLogIn: activityBeforeLogIn
  server: {
    activity: MathVaultActivity
  }
  loading: boolean
  streak: number
  navigations: {
    prevLevel: number
    prevActivity: number
    nextLevel: number
    nextActivity: number
  }
  pickedEgg: boolean
  pickedTempEgg: boolean
}

export interface MathVaultLocation {
  room: VaultSpawnLocations
  chest: null | string
}

interface MathVaultData {
  key: string
  h1: string
  path: string
}

export type MathVaultLink = MathVaultData & {
  activeClass: {
    bg: string
    text: string
  }
  key: string
  children?: MathVaultLink[]
}

export enum RibbonText {
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  FINISHED = 'finished',
}
